import React from 'react';
import styled from 'styled-components';
import { PageContainer } from '../components/PageContainer';
import { PrimaryFont, TaglineFont } from '../components/styles';
import { EXTERNAL_LINKS } from '../utils/links';
import { THEME_COLORS } from '../utils/theme';

const Group = styled.div`
  margin-bottom: 60px;
`;

const Question = styled(PrimaryFont).attrs({ bold: true })`
  display: block;
  font-size: 24px;
  margin-bottom: 20px;
`;

const Answer = styled(PrimaryFont)`
  display: block;
  font-size: 18px;
  line-height: 26px;
`;

const Title = styled(TaglineFont)`
  display: block;
  font-size: 40px;
  line-height: 1.4em;
  margin-bottom: 80px;
`;

const InlineLink = styled.a`
  color: ${THEME_COLORS.text};
`;

export const PageFAQ: React.FC = () => {
  return (
    <PageContainer>
      <Title>
        Are you still puzzled?
        <br />
        Then you're in the right place.
      </Title>
      <Group>
        <Question>Who can attend?</Question>
        <Answer>
          We encourage and welcome undergraduate students in North America (US, Canada, Mexico) of all backgrounds to
          join us. Unfortunately, we are unable to admit high school and graduate students. Priority will be given to UW
          undergraduate students.
        </Answer>
      </Group>
      <Group>
        <Question>When do applications close?</Question>
        <Answer>
          Priority applications close on October 1st, 2021 at 11:59 p.m. (PDT), and general applications close on
          October 8th, 2021 at 11:59 p.m (PDT).
        </Answer>
      </Group>
      <Group>
        <Question>What is the code of conduct?</Question>
        <Answer>
          DubHacks values the importance of a safe and all-inclusive space. We welcome students from all backgrounds.
          Anyone attending must adhere to our{' '}
          <InlineLink href={EXTERNAL_LINKS.CODE_OF_CONDUCT} rel="noopener noreferrer" target="_blank">
            Code of Conduct
          </InlineLink>
          .
        </Answer>
      </Group>
      <Group>
        <Question>What if I don’t know how to code?</Question>
        <Answer>
          Interest in learning and working with technology is much more important than your current experience level. No
          experience is needed — whether you're a coder, an artist, a designer, or a writer, you'll get a chance to work
          with various mentors, attend workshops, interact with companies, and learn alongside fellow participants.
        </Answer>
      </Group>
      <Group>
        <Question>How much does DubHacks '21 cost?</Question>
        <Answer>
          Participation is completely free. Just bring yourself and your best ideas, and we take care of the rest!
        </Answer>
      </Group>
      <Group>
        <Question>How big are the teams?</Question>
        <Answer>
          You may work individually or on a team of no more than 4 people. Due to the number of applications we receive,
          we are unable to admit pre-formed teams. Once you receive your acceptance, you will be sent an email further
          prompting you on our team formation opportunities.
        </Answer>
      </Group>
      <Group>
        <Question>Do I apply with a team?</Question>
        <Answer>No, applications are submitted and reviewed individually.</Answer>
      </Group>
      <Group>
        <Question>What if I don't have a team?</Question>
        <Answer>
          You will receive an invite to our Facebook community group and Slack workspace where you can introduce
          yourself and find potential team members.{' '}
        </Answer>
      </Group>
      <Group>
        <Question>How do I choose a track?</Question>
        <Answer>
          Upon arriving at DubHacks, you and your team will select a track to hack in. In order to be considered for
          DubHacks prizes, you will have to submit your project to a specific track. It's up to your team to decide!
        </Answer>
      </Group>
      <Group>
        <Question>Are we allowed to build on past projects?</Question>
        <Answer>
          You cannot work, copy, or iterate on past projects. Using your own APIs or third-party APIs is allowed, as
          long as the project is completely new.
        </Answer>
      </Group>
      <Group>
        <Question>What if I need special accommodations?</Question>
        <Answer>
          DubHacks aims to be accessible and welcoming for everyone. Please list any special accommodations in your
          admissions, or contact us with any other concerns!
        </Answer>
      </Group>
      <Group>
        <Question>404: Question Not Found</Question>
        <Answer>
          If you have any other questions or concerns, reach out to us via Facebook, Twitter, Instagram, or send us an
          email to <InlineLink href={'mailto:info@dubbhacks.co'}>info@dubhacks.co</InlineLink>.
        </Answer>
      </Group>
    </PageContainer>
  );
};
